// DTOs for invoice data received from supplier APIs (e.g., Uniformax)
// These are plain interfaces (not Breeze entities) used for API responses
// NOTE: Property names use PascalCase to match Uniformax's JSON serialization
// (Uniformax uses Newtonsoft.Json with Breeze settings that don't use camelCase)

import { JobOrderHistDetail } from './job-order-hist-detail';

export interface InvoiceDetailDTO {
  id: string;
  joDetailId: string;
  shipQty: number;
  redistributeQty: number;

  // Product information
  manufacturerName?: string;
  sku?: string;
  description?: string;
  features?: string;

  // Pricing
  unitPriceAmt: number;
  unitOversizeAmt: number;
  unitCustomAmt: number;
  unitReissueAmt: number;

  // Computed properties (calculated on server)
  totalUnitAmt: number; // UnitPriceAmt + UnitOversizeAmt + UnitCustomAmt
  extendedAmt: number; // TotalUnitAmt * ShipQty
  extendedReissueAmt: number; // UnitReissueAmt * RedistributeQty

  // next two fields are populated by fixupMethod below
  invoiceHeader: InvoiceHeaderDTO; // navigation back to parent invoice header
  jobOrderHistDetail: JobOrderHistDetail;
}

export interface InvoiceHeaderDTO {
  id: string;
  apiLink: string;
  invoiceNumber?: string;
  joHeaderId: string;
  invoiceStatusId?: string;
  invoiceStatusName?: string;
  invoiceDate: Date;
  dueDate: Date;
  shipTs?: Date;
  shipExpirationDate?: Date;
  orderHandlingAmt: number;
  freightAmt: number;
  subtotalAmt: number;
  taxAmt: number;
  totalAmt: number;
  prepaymentAmt: number;
  paymentAmt: number;
  createdTs?: Date;
  invoiceDetails: InvoiceDetailDTO[];
  shipmentId?: number;

  // Shipment tracking (from supplier — may not be available)
  carrierName?: string;
  serviceName?: string;
  trackingUrl?: string;
  trackingNumbers?: string[];
}

/**
 * Result of querying invoices from supplier system.
 * Distinguishes between "no invoices found" (success with empty list)
 * and "server unavailable" (failure with error message).
 */
export interface InvoiceQueryResultDTO {
  success: boolean;
  errorMessage?: string;
  invoices: InvoiceHeaderDTO[];
}
